module.exports = __webpack_public_path__ + "img/expostyle_0901_mid_green_pantone7727c.8e5ff33b.jpg";